var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef } from 'react';
import { MenuIcon } from './Icons/MenuIcon';
import { MenuLink } from './MenuLink';
import { SubMenu } from './SubMenu';
import { MenuWrapper, MenuContent, MenuButton, MenuLinks, Container } from './style';
export var Menu = function (props) {
    var _a = useState(false), isMenuOpen = _a[0], setIsMenuOpen = _a[1];
    var _b = useState(false), isScrollUp = _b[0], setIsScrollUp = _b[1];
    var _c = useState(false), isScrollOut = _c[0], setIsScrollOut = _c[1];
    var menuRef = useRef(null);
    var getMenuTop = function () { return menuRef.current.parentElement.offsetTop || menuRef.current.parentElement.getBoundingClientRect().top + window.scrollY; };
    var scrollY = 0;
    var handleScroll = function () {
        setIsScrollUp(scrollY >= window.scrollY);
        //только для внутренних страниц (во внутренних используется обертка для меню чтобы считать положение относительно верха страницы)
        props.isInnerPage && setIsScrollOut(window.scrollY > getMenuTop() + (scrollY >= window.scrollY ? 0 : 45)); //высота хедера или хедера и меню
        scrollY = window.scrollY;
    };
    useEffect(function () {
        if (!props.noScroll) {
            window.addEventListener('scroll', handleScroll, false);
            return function () { return window.removeEventListener('scroll', handleScroll, false); };
        }
        return;
    }, []);
    return (React.createElement(MenuWrapper, { "$isScrollUp": isScrollUp || isMenuOpen /* всегда показываем кнопку меню когда открыто */, "$isScrollOut": isScrollOut, ref: menuRef },
        React.createElement(Container, { "$position": 'initial', "$padding": '0', "$maxWidth": props.width },
            React.createElement(MenuContent, null,
                React.createElement(MenuButton, { onClick: function () { return setIsMenuOpen(!isMenuOpen); } },
                    React.createElement(MenuIcon, null)),
                props.currentAct !== 'olymp_en' ? // if has image
                    React.createElement(MenuLinks, null,
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'default', content: React.createElement(MenuIcon, null) })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'diag', content: '\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'ias', content: '\u0422\u0440\u0435\u043D\u0430\u0436\u0435\u0440\u044B' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'test_constructor', content: '\u0422\u0435\u0441\u0442\u2011\u041A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'fepo_pro', content: '\u0424\u042D\u041F\u041E-pro' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'fepo', content: '\u0424\u042D\u041F\u041E' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'olymp', content: '\u041E\u043B\u0438\u043C\u043F\u0438\u0430\u0434\u044B' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'fieb', content: '\u0424\u0418\u042D\u0411' })),
                        React.createElement(MenuLink, __assign({}, props, { actMode: 'tfieb', content: '\u0422\u0440\u0435\u043D\u0430\u0436\u0435\u0440\u00A0\u0424\u0418\u042D\u0411' })))
                    :
                        React.createElement(MenuLinks, null,
                            React.createElement(MenuLink, __assign({}, props, { actMode: 'olymp_en', content: 'Menu' }))))),
        isMenuOpen && React.createElement(SubMenu, __assign({}, props, { actMode: props.currentAct }))));
};
//# sourceMappingURL=index.js.map